export class Payment {

  public id: number;
  public agreementId: number;
  public totalAmount: number;
  public paymentStatus: string;

  public invoicePath: string;
  public paymentsDate: any;
  public cardType: string;
  public cardLastNumbers: string;
  public subscriptionTitle: string;
  public invoiceId: number;
  public paymentType: string;

}
